export default {"src":"/_next/static/media/fractions.1a1998d9.svg","height":20,"width":20};